<template>
	<v-flex xs12>
		<v-container fluid grid-list-md> 	
    		<v-text-field
    		v-model="videoFull"
    		:label="translater.__('Youtube Video Link', 'tasks')"
    		></v-text-field>
    		<v-card-actions>
			        	<!--v-btn flat :disabled="!valid" @click="store()" small color="success">
			        		<v-icon>save</v-icon>
			        		{{translater.__('Save')}}
			        	</v-btn-->
						<SuccessButton :valid="valid" :onClick="store"></SuccessButton>
			        	<!--v-btn flat @click="add = false" small color="error">
			        		<v-icon>cancel</v-icon>
			        		{{translater.__('Cancel')}}
			        	</v-btn-->
						<ErrorButton :onClick="() => add = false"></ErrorButton>
			        </v-card-actions>
    	</v-container>
	</v-flex>
</template>

<script>
	import SuccessButton from '../../../common/components/SuccessButton'
	import ErrorButton from '../../../common/components/ErrorButton'
	export default {
		name: 'YoutubeVideo',
		components: {SuccessButton, ErrorButton},


		methods: {
			store()
			{
				this.$store.dispatch('checkpoints/storeYoutubeVideoTask')
			}
		},

		computed: {

		

			translater: {
				get()
				{
					return this.$store.getters['translate/translater']
				}
			},

			videoFull: {
				get()
				{
					return this.$store.getters['checkpoints/video'].full
				},

				set(value)
				{

					this.$store.dispatch('checkpoints/setVideo', value)
				}
			},

			valid: {
				get()
				{
					return this.$store.getters['checkpointsValidator/isValid']
				}
			},

			add: {
				get()
				{
					return this.$store.getters['checkpoints/add']
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setAddCheckpoint', value)
				}

			},
		}

	}
</script>